var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [_vm._v("Failed Post")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.postAgain.apply(null, arguments)
                }
              }
            },
            [_vm._v("Post")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "app-filter-good-table-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "social-media-calendar bottom-employee-detail col-12 float-l",
                staticStyle: { "background-color": "white" }
              },
              [
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full p-3"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selected.title) +
                            "\n                              "
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info btn-lg",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "button",
                              id: "openModel",
                              "data-toggle": "modal",
                              "data-target": "#myModal"
                            }
                          },
                          [_vm._v("Open Modal")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-color-table mt-20 float-l width-full"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm.selected.media_type != null
                                            ? [
                                                _vm._v(
                                                  "\n                                              " +
                                                    _vm._s(
                                                      _vm.capitalizeFirstLetter(
                                                        _vm.selected.media_type
                                                      )
                                                    ) +
                                                    "\n                                              "
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                              " +
                                              _vm._s(
                                                _vm.capitalizeFirstLetter(
                                                  _vm.selected.contact_person
                                                )
                                              ) +
                                              "\n                                              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                              " +
                                              _vm._s(_vm.selected.company) +
                                              "\n                                                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.selected.start_date_time
                                              ) +
                                              "\n                                              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.selected.contact_number != ""
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bus-detail-row width-full float-l"
                                      },
                                      [
                                        _vm._m(8),
                                        _vm._v(" "),
                                        _vm._m(9),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-inner-detail col-number colpie-60 float-l"
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "color-blue heading-text-14 line-height-18"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selected
                                                        .contact_number
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-color-table mt-20 float-l width-full"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(10),
                                  _vm._v(" "),
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.selected.profile_name
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l"
                                },
                                [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                              " +
                                              _vm._s(
                                                _vm.selected.contact_email
                                              ) +
                                              "\n                                              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l "
                                },
                                [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.selected.has_tags) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bus-detail-row width-full float-l "
                                },
                                [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _vm._m(17),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-inner-detail col-number colpie-60 float-l"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "color-blue heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.selected.failed_date) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        staticClass:
                          "mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"
                      },
                      [_vm._v(" Description ")]
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" },
                        [
                          _c("div", {
                            staticClass:
                              "social-media-description bg-color-table mt-20 mb-20 float-l width-full",
                            domProps: {
                              innerHTML: _vm._s(_vm.selected.description)
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "h2",
                      {
                        staticClass:
                          "mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"
                      },
                      [_vm._v(" Error ")]
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" },
                        [
                          _c("div", {
                            staticClass:
                              "social-media-description bg-color-table mt-20 mb-20 float-l width-full",
                            domProps: { innerHTML: _vm._s(_vm.selected.error) }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.selectedAttachments > 0
                      ? [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"
                            },
                            [
                              _vm._v(
                                " Attachments\n                              "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary pull-right",
                                  attrs: { type: "button", id: "DownloadAll" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.downloadAllAttachments(
                                        _vm.selected.id
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Download All")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-sm-12 col-md-12 col-lg-12"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "social-media-description bg-color-table mt-20 mb-20 float-l width-full"
                                  },
                                  [
                                    [
                                      _c(
                                        "swiper",
                                        {
                                          ref: "swiperAttachment",
                                          attrs: {
                                            options: _vm.swiperOptionAttachments
                                          }
                                        },
                                        [
                                          _vm._l(_vm.selected.media, function(
                                            doc,
                                            index1
                                          ) {
                                            return [
                                              doc.type.toLowerCase() == "image"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.imageUrl(
                                                            doc.document
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openGallery(
                                                              _vm.selected
                                                                .media,
                                                              index1
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                : doc.type.toLowerCase() ==
                                                  "video"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c("img", {
                                                        staticClass:
                                                          "link-icon",
                                                        attrs: {
                                                          src:
                                                            "/static/images/video-icon.png"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.downloadImage(
                                                              doc.document
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                : doc.extension.toLowerCase() ==
                                                    "doc" ||
                                                  doc.extension.toLowerCase() ==
                                                    "docx"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: doc.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "link-icon",
                                                            attrs: {
                                                              src:
                                                                "/static/images/doc-icon.png"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                : doc.extension.toLowerCase() ==
                                                    "xls" ||
                                                  doc.extension.toLowerCase() ==
                                                    "xlsx"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: doc.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "link-icon",
                                                            attrs: {
                                                              src:
                                                                "/static/images/xl-icon.png"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                : doc.extension.toLowerCase() ==
                                                    "ppt" ||
                                                  doc.extension.toLowerCase() ==
                                                    "pptx"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: doc.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "link-icon",
                                                            attrs: {
                                                              src:
                                                                "/static/images/ppt-icon.png"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                : doc.extension.toLowerCase() ==
                                                  "pdf"
                                                ? [
                                                    _c("swiper-slide", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: doc.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "link-icon",
                                                            attrs: {
                                                              src:
                                                                "/static/images/pdf-icon.png"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                : [
                                                    _c("swiper-slide", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: doc.url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "link-icon",
                                                            attrs: {
                                                              src:
                                                                "/static/images/link-icon.png"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "modal fade socialmediacalendarpopup",
                        attrs: { id: "myModal", role: "dialog" }
                      },
                      [
                        _c("div", { staticClass: "modal-dialog modal-lg" }, [
                          _c("div", { staticClass: "modal-content" }, [
                            _c("div", { staticClass: "modal-body" }, [
                              _c("img", {
                                staticClass: "w-100 mb-3",
                                attrs: { src: _vm.viewImage }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "ml-2 btn btn-primary pull-right themebutton",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeImage("previous")
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-angle-left",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "ml-2 btn btn-primary pull-right themebutton",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeImage("next")
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "ml-2 btn btn-primary pull-right themebutton",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadZip(_vm.viewImage)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-download",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  2
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Social Media  ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Person ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Companies To Share With ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Post Date ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Number ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Social Media Profile ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Email ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Hash Tags ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Failed Date ")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73d054f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d054f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/FailedPostDetail.vue
// module id = null
// module chunks = 